import script from "./BuscadorContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscadorContainer.vue?vue&type=script&setup=true&lang=js"

import "./BuscadorContainer.vue?vue&type=style&index=0&id=db5438aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db5438aa"]])

export default __exports__